import { InjectionToken } from '@angular/core';
import { IFormService } from '@shared/services/forms/form.models';

export const FormServiceInjectionToken = new InjectionToken<IFormService<any>>('FORM_SERVICE_TOKEN');
